import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';

import {AuthenticationService} from '../app/utils/authentication.service';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class AuthGuard implements CanActivate {

  constructor(private router: Router,
    private _authService: AuthenticationService) { }

  canActivate() {
    if (localStorage.getItem('currentUser')) {
      // logged in so return true
      return true;
    }
    //
    //   this._authService.checkUser()
    //     .subscribe(
    //     results => {
    //       if (results) {
    //         console.log("zaloguj")
    //         return true;
    //       }
    //       else {
    //         this.router.navigate(['/sign-in']);
    //           console.log("nie zaloguj");
    //         return false;
    //       }
    //     },
    //     error => console.log(<any>error)
    //     );
//     }

    this.router.navigate(['/sign-in']);
    return false;

  }
}



// WEBPACK FOOTER //
// ./src/common/auth.guard.ts